const errors = {
  buttonLogoutText: 'Sair do sistema',
  logout: {
    heading: 'Atenção!',
    title: 'O acesso ao sistema não foi autorizado.',
    description:
      'Tente entrar novamente ou entre em contato com o nosso <a href="https://suporte.antecipa.com/hc/pt-br" target="_blank">suporte</a>.',
    errorCode: '',
    buttonText: 'Sair do sistema',
  },
  error500: {
    heading: 'Desculpe-me!',
    title: 'Estou com problemas.',
    description:
      'Caso persista, entre em contato com o nosso <a href="https://suporte.antecipa.com/hc/pt-br" target="_blank">suporte</a>.',
    errorCode: 'Código do erro: 500',
    buttonText: 'Recarregar a página',
  },
  error404: {
    heading: 'Oops!',
    title: 'Parece que este conteúdo não existe ou não está mais disponível.',
    description: '',
    errorCode: 'Código do erro: 404',
    buttonText: 'Voltar à página inicial',
  },
  error403: {
    heading: 'Que pena!',
    title: 'Parece que você não tem autorização para acessar esta área.',
    description:
      'Caso persista, entre em contato com o nosso <a href="https://suporte.antecipa.com/hc/pt-br" target="_blank">suporte</a>.',
    errorCode: 'Código do erro: 403',
    buttonText: 'Voltar à página principal',
  },
  'internal-server-error': 'Ops! Erro ao executar operação',
};

export default errors;
